import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from "./Pages/layout/footer/footer.component";
import { BasicAlertComponent } from "./core/Component/basic-alert/basic-alert.component";
import { Subscription, filter } from 'rxjs';
import { LanguageService } from './core/Services/language.service';

@Component({
  selector: 'app-root',
  imports: [FooterComponent, RouterOutlet, BasicAlertComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'in2Padel';
  showFooter = true;
  private routerSubscription = new Subscription();

  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    // Ensure dir/lang/font are initialized even on routes without HeaderComponent.
    this.languageService.getCurrentLanguage();
    this.setFooterVisibility(this.router.url);

    this.routerSubscription.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          const navigationEnd = event as NavigationEnd;
          this.setFooterVisibility(navigationEnd.urlAfterRedirects);
        })
    );
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  private setFooterVisibility(url: string): void {
    const cleanUrl = (url || '')
      .split('?')[0]
      .split('#')[0]
      .replace(/\/+$/, '') || '/';
    this.showFooter = cleanUrl !== '/thank-you' && cleanUrl !== '/redirect';
  }
}
